<template>
    <div v-for="item in formData.fines" :key="item.productType" class="pb-9">
        <div class="text-h5 pb-5">
            {{ $t('cancellation_policy_for') }}
            {{ `'${$t(`productType.${item.productType}`)}'` }}
        </div>
        <div class="font-weight-bold pb-3">{{ $t('independent_cancellation_policies') }}:</div>
        <div class="pb-6">
            <div class="d-flex align-center flex-wrap gr-1 gc-3">
                {{ $t('cancellation_fee') }}
                <v-number-input
                    v-model="item.period"
                    :min="0"
                    :max="120"
                    hide-details
                    max-width="100"
                    :data-cy="`period-for-${item.id}`"
                    density="compact"
                />
                {{ $t('days_before_requested_arrival_date') }}
                <v-number-input
                    v-model="item.percent"
                    :min="0"
                    :max="100"
                    hide-details
                    max-width="100"
                    :data-cy="`percent-for-${item.id}`"
                    density="compact"
                />
                % {{ $t('of') }}
                <v-select
                    v-model="item.baseFine"
                    :items="baseFineTypes(item.productType)"
                    hide-details
                    max-width="180"
                    :data-cy="`base-fine-for-${item.id}`"
                    density="compact"
                />
            </div>
        </div>
        <div class="font-weight-bold pb-3">
            {{ $t('management_of_supplier_cancellation_policies') }}
        </div>
        <div>
            <div class="d-flex align-center flex-wrap gr-1 gc-3">
                {{ $t('period_shifted_by') }}
                <v-number-input
                    v-model="item.extendedPeriodDays"
                    :min="0"
                    :max="120"
                    hide-details
                    max-width="100"
                    :data-cy="`days-period-for-${item.id}`"
                    density="compact"
                />
                {{ $t('period_shifted_by_days') }}
                <v-number-input
                    v-model="item.markupPercent"
                    :min="0"
                    :max="100"
                    hide-details
                    max-width="100"
                    :data-cy="`markup-period-for-${item.id}`"
                    density="compact"
                />
                %
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()

    const {t} = useI18n()

    const baseFineTypes = productType => {
        if (productType === 'accommodation') {
            return [
                {value: 'ALL_COST', title: t('baseFineTypes.ALL_COST')},
                {value: 'ONE_NIGHT', title: t('baseFineTypes.ONE_NIGHT')},
            ]
        }
        return [{value: 'ALL_COST', title: t('baseFineTypes.ALL_COST')}]
    }
</script>
